require('./bundle-manifest').register(JSON.parse("{\"1LASy\":\"index.b92c62b7.js\",\"1unOv\":\"Roboto.f1eaae19.json\",\"4k2TF\":\"index.032bd87b.css\"}"));